<template>
    <div class="content">
        <div>
            <span class="fontTrace  icon-a-chaxunweizhengpin1x" style="font-size:64px"  :style="'color:'+gobleStyle.themeColor"></span>
        </div>
        <!-- <img src="@/assets/images/scan/first_fw.png" alt="" style="width:64px;margin-bottom:25px"> -->
        <p>该二维码已被查询过10次</p>
        <p>首次查询时间为 2021-06-03 15:00:12</p>
        <a href="javascript:;">查询明细</a>
    </div>
</template>
<script>
export default {
    props: { data: Object,gobleStyle:Object },
}
</script>
<style lang="less" scoped>
.content{
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding:30px 0px 25px 0;
    color: #343434;
    font-size: 14px;
    font-weight: 500;
    p{
        margin-bottom: 12px;
    }
    a{
        margin-top: 25px;
        color:#4FA1FC;
        text-decoration: underline;
    }
}
</style>